<template>
  <b-form-group id="colorContrast" horizontal label-cols="3" label-size="md" :label="$t('labels.colorContrast') + ':'">
    <b-row>
      <b-col lg="5">
        <label for="Regular" class="customi_label">
          <input type="radio" id="Regular" name="contrast" value="Regular" class="invisible customi_input" v-model="contrast">
            <div class="customi_div radio">
              <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
                <circle class="svg_bg" cx="10" cy="10" r="9"/>
                <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
              </svg>
            </div>
          <span>{{ $t("labels.normal")}}</span>
        </label>
      </b-col>
      <b-col lg="5">
        <label for="HighContrast" class="customi_label">
          <input type="radio" id="HighContrast" name="contrast" value="HighContrast" class="invisible customi_input" v-model="contrast">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>{{ $t("labels.highContrast")}}</span>
        </label>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  name: 'colorContrast',
  data () {
    return {
      contrast: localStorage.getItem('contrast') ? localStorage.getItem('contrast') : 'Regular',
      checked: true
    };
  },
  watch: {
    contrast (val) {
      localStorage.setItem('contrast', val);
      this.$parent.$parent.$parent.updateUIAfterThemeChanged();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Settings/colorContrast.vue